import Seo from "@/components/Seo";
import B2B from "@/components/landing/B2B";
import Contact from "@/components/landing/Contact";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import Reveal from "@/components/landing/Reveal";

const POINTS = [
  "Wholesale pricing on cabinets, countertops & materials",
  "Priority scheduling for your projects",
  "A dedicated project manager across every trade",
  "One licensed, insured partner for the whole build",
];

export default function Builders() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: "Builder Partnership Program",
    name: "Builder Partnership Program in Charlotte, NC",
    provider: { "@id": "https://almeidashomeservices.com/#business" },
    areaServed: ["Charlotte, NC", "Pineville, NC", "Matthews, NC", "Fort Mill, SC", "Rock Hill, SC"],
    url: "https://almeidashomeservices.com/builders",
  };

  return (
    <>
      <Seo
        title="Builder Partnership Program in Charlotte, NC | Almeida's"
        description="One partner, multiple trades. Wholesale pricing, priority scheduling and a dedicated project manager for builders and GCs across NC & SC."
        path="/builders"
        jsonLd={jsonLd}
      />

      <section className="bg-navy-dark pt-32 pb-16 md:pt-40 md:pb-20">
        <div className="max-w-[1100px] mx-auto px-5 md:px-12">
          <Reveal>
            <Link to="/" className="font-body text-gold/80 hover:text-gold text-sm">← Home</Link>
            <span className="block mt-5 font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">For Builders & Contractors</span>
            <h1 className="mt-3 font-display font-bold uppercase text-white text-4xl md:text-6xl leading-[0.92] tracking-tight max-w-[16ch]">
              One Partner. Multiple Trades. Better Results.
            </h1>
            <div className="mt-8 grid sm:grid-cols-2 gap-3 max-w-2xl">
              {POINTS.map((p) => (
                <div key={p} className="flex items-start gap-3">
                  <span className="shrink-0 w-7 h-7 rounded-full bg-gold flex items-center justify-center mt-0.5">
                    <Check size={15} className="text-navy-dark" strokeWidth={3} />
                  </span>
                  <span className="font-body text-white/85">{p}</span>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <B2B variant="full" />
      <Contact />
    </>
  );
}
